<template>
  <transition name="fade" mode="out-in">
    <div v-if="finish">
      <Icon
        type="check"
        backgroundColor="green"
        borderColor="green"
        :rounded="true"
        :size="1.5"
      />
      <Divider />
      <p>
        Succesfully Deactivated
      </p>
      <DecoratedButton type="button" @click="close">
        CLOSE
      </DecoratedButton>
    </div>
    <form v-else v-on:submit.prevent="deactivate">
      <DecoratedButton :loading="loading" type="submit">
        DEACTIVATE
      </DecoratedButton>
    </form>
  </transition>
</template>

<script>
export default {
  name: "profile-modal-two-factor-deactivate",
  data: function() {
    return {
      loading: false,
      finish: false
    };
  },
  methods: {
    deactivate() {
      this.$validator.validateAll("code").then(valid => {
        if (valid) {
          this.loading = true;

          this.services.UserResource.authCodeDeactivate({})
            .then(response => {
              this.finish = true;
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input {
  text-align: center;
}

.img {
  border: 4px solid #000000;
}
</style>
